import React, { ReactNode } from "react"

type ChatStatusBarProps = {
  children: ReactNode
}

export default function ChatStatusBar({ children }: ChatStatusBarProps) {
  return (
    <div className="absolute -top-1 flex w-full -translate-y-full justify-center rounded-md border-b-0 border-transparent bg-warning-100 px-3 py-1.5 text-center text-black">
      {children}
    </div>
  )
}
